<div class="review-changes-container">
    <div class="review-page-header">
        <div class="header-content">
            <h3>Review Changes - {{ schemaType }} Schema</h3>
            <div class="sub-header">Well: {{ wellName }} | Compare your edited data with original values</div>
        </div>
    </div>

    <div class="review-content-scroll">
        <!-- Side by Side Comparison View -->
        <div class="side-by-side-container">
            <div class="comparison-body">
                <!-- Current Data Column (Left) -->
                <div class="comparison-column current-data">
                    <div class="column-header">
                        <div class="header-left">
                            <span class="material-icons">storage</span>
                            Current Data
                        </div>
                    </div>
                    <div class="scrollable-content">
                        <!-- Skeleton Loading for Current Data -->
                        <div *ngIf="currentDataLoading" class="current-data-skeleton">
                            <div class="table-wrapper">
                                <table class="data-table skeleton-table vertical-headers">
                                    <tbody>
                                        <tr *ngFor="let key of getFilteredDisplayKeys()">
                                            <th>
                                                <div class="skeleton-cell"></div>
                                            </th>
                                            <td *ngFor="let i of [1,2]">
                                                <div class="skeleton-cell"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                        <!-- Current Data Table -->
                        <div *ngIf="!currentDataLoading && currentData && currentData.length > 0" class="table-wrapper">
                            <table class="data-table vertical-headers">
                                <tbody>
                                    <tr *ngFor="let key of getFilteredDisplayKeys()">
                                        <th>
                                            <div class="th-header">
                                                <span>{{ getDisplayLabel(key) }}</span>
                                                <!-- Show toggle only for fields with unit variants -->
                                                <div class="unit-toggle-inline" *ngIf="hasUnitVariants(key)">
                                                    <button 
                                                        *ngFor="let unit of getAvailableUnitsForField(key)"
                                                        class="unit-btn-inline" 
                                                        [class.active]="getSelectedUnitForField(key) === unit"
                                                        (click)="setSelectedUnit(key, unit)"
                                                        [title]="'Show values in ' + unit">
                                                        {{ getUnitDisplayLabel(unit) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </th>
                                        <td *ngFor="let record of currentData; let i = index">
                                            {{ formatValue(key, getValueForUnit(record, key)) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div *ngIf="!currentDataLoading && (!currentData || currentData.length === 0)" class="no-data-message">
                            <span class="material-icons">info</span>
                            <p>No current data available</p>
                        </div>
                    </div>
                </div>

                <!-- Well View Data Column (Right) -->
                <div class="comparison-column well-view-data">
                    <div class="column-header">
                        <div class="header-left">
                            <span class="material-icons">visibility</span>
                            Well View Data
                        </div>
                    </div>
                    <div class="scrollable-content">
                        <!-- Skeleton Loading for Well View Data -->
                        <div *ngIf="wellViewDataLoading" class="well-view-data-skeleton">
                            <div class="table-wrapper">
                                <table class="data-table skeleton-table vertical-headers">
                                    <tbody>
                                        <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
                                            <th>
                                                <div class="skeleton-cell"></div>
                                            </th>
                                            <td *ngFor="let j of [1,2]">
                                                <div class="skeleton-cell"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                        <!-- Well View Data Table -->
                        <div *ngIf="!wellViewDataLoading && wellViewData && wellViewData.length > 0" class="table-wrapper">
                            <table class="data-table vertical-headers">
                                <tbody>
                                    <tr *ngFor="let key of getWellViewDisplayKeys()">
                                        <th>
                                            <div class="th-header">
                                                <span>{{ getDisplayLabel(key) }}</span>
                                                <!-- Show toggle only for fields with unit variants -->
                                                <div class="unit-toggle-inline" *ngIf="hasUnitVariants(key)">
                                                    <button 
                                                        *ngFor="let unit of getAvailableUnitsForField(key)"
                                                        class="unit-btn-inline" 
                                                        [class.active]="getSelectedUnitForField(key) === unit"
                                                        (click)="setSelectedUnit(key, unit)"
                                                        [title]="'Show values in ' + unit">
                                                        {{ getUnitDisplayLabel(unit) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </th>
                                        <td *ngFor="let record of wellViewData; let i = index">
                                            {{ formatValue(key, getValueForUnit(record, key)) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div *ngIf="!wellViewDataLoading && (!wellViewData || wellViewData.length === 0)" class="no-data-message integration-pending">
                            <span class="material-icons">hourglass_empty</span>
                            <p>Well View Data</p>
                            <p class="hint">No data available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-actions">
        <button class="btn btn-secondary" (click)="onBack()" [disabled]="isSubmitting">
            <span class="material-icons">arrow_back</span>
            Back to Edit
        </button>
        <button class="btn btn-success" (click)="onSubmit()" [disabled]="isSubmitting">
            <span class="material-icons">{{ isSubmitting ? 'hourglass_empty' : 'send' }}</span>
            {{ isSubmitting ? 'Preparing the data...' : 'Prepare' }}
        </button>
    </div>
</div>
